import React from 'react';
import { Quote } from 'lucide-react';
import styles from './SuccessStories.module.css';

const SuccessStories = () => {
    const stories = [
        {
            name: "Barack Obama",
            subtitle: "Former U.S. President",
            description: "Improved his skills through practice and preparation. Became known for his inspiring and articulate speeches."
        },
        {
            name: "Mahatma Gandhi",
            subtitle: "Indian Independence Leader",
            description: "Initially shy and struggled with public speaking. Practiced and became a powerful orator."
        },
        {
            name: "Elon Musk",
            subtitle: "Tech Entrepreneur",
            description: "Learned to communicate complex ideas effectively. Engages audiences with passion and vision."
        },
        {
            name: "Yasir Khan",
            subtitle: "Public Speaking Coach",
            description: "Transformed from overcoming anxiety and language barriers to becoming a leading public speaking coach for CEOs and professionals."
        }
    ];

    return (
        <section className={styles.successSection}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <Quote size={32} className={styles.quoteIcon} />
                    <h2 className={styles.sectionTitle}>Notable Success Stories</h2>
                    <p className={styles.sectionSubtitle}>
                        Individuals who developed their public speaking skills over time
                    </p>
                </div>

                <div className={styles.storiesGrid}>
                    {stories.map((story, index) => (
                        <div key={story.name} className={styles.storyCard}>
                            <div className={styles.storyHeader}>
                                <span className={styles.storyNumber}>0{index + 1}</span>
                                <div className={styles.storyTitles}>
                                    <h3 className={styles.storyName}>{story.name}</h3>
                                    <p className={styles.storyRole}>{story.subtitle}</p>
                                </div>
                            </div>
                            <div className={styles.storyContent}>
                                <p className={styles.storyDescription}>{story.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SuccessStories;